import { FeatureAppLoader } from '@feature-hub/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import { actionRedirect, getFinanciacionType, getPagoFinanciado, getPagoUnico } from '../helpers/ofertas-helper';
import { Oferta } from '../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../tracking/use-tracking-manager';

export const RedirectCTAs = ({
	oferta,
	copy,
	isMobile,
	emphasis,
	trackingRef,
	formTrigger,
}: {
	oferta: Oferta;
	copy: string;
	isMobile: boolean;
	emphasis: 'primary' | 'secondary';
	trackingRef?: string;
	formTrigger: string;
}) => {
	const { featureAppService, userInteractionService } = React.useContext(OfertasContext);
	const [showOneformV1, setShowOneformV1] = useState<boolean>(false);
	const trackingManager = useTrackingManager();

	const handleOnClick = () => {
		const pagoFinanciado = getPagoFinanciado(oferta.datosEconomicos);
		trackingManager.trackOfertasButtonClick(
			copy,
			{ contentId: trackingRef ? `${copy} - ${trackingRef}` : copy },
			{
				CarlineId: oferta.carline?.code.toString(),
				CarlineName: oferta.carline?.title,
				ModelId: oferta.configuracion.motorizacion.code?.split('-')[0],
				ModelName: oferta.carline?.salesgroup.model.name,
				ModelYear: oferta.carline?.salesgroup.year.toString(),
				SalesgroupName: oferta.carline?.salesgroup.title,
				PriceRateType: pagoFinanciado ? getFinanciacionType(pagoFinanciado) : undefined,
				PriceRateTotal: pagoFinanciado?.precio ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal: getPagoUnico(oferta.datosEconomicos)?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			},
		);

		if (formTrigger === 'es-oneform-v2') {
			actionRedirect(
				userInteractionService,
				`es-oneform-v2-action--open_layer?formName=lead_venta-presupuesto&featureApp=esofertasv2&ofertaId=${oferta.id}&carline=${oferta.carline?.name}`,
			);
		} else {
			setShowOneformV1(true);
		}
	};

	const renderOneformV1 = () => {
		const featureApp = showOneformV1 ? featureAppService.featureAppConfigurations[formTrigger] : undefined;
		if (!featureApp) {
			return null;
		}

		return (
			<FeatureAppLoader
				{...featureApp}
				featureAppId={`${featureApp.name}:oneform`}
				done={() => setShowOneformV1(false)}
				beforeCreate={(env) => {
					const faContentService = env.featureServices['fa-content-service'] as { content: unknown } | undefined;
					if (faContentService) {
						faContentService.content = {
							featureApp: 'es-ofertas',
							oferta: oferta,
						};
					}
					const apiKeyProvider = env.featureServices['api-key-provider'] as { apiKey?: string } | undefined;
					if (apiKeyProvider) {
						apiKeyProvider.apiKey = featureApp.apiKey;
					}
					const tracking = env.featureServices.tracking as { contextualEventData?: unknown } | undefined;
					if (tracking) {
						tracking.contextualEventData = {
							event: {
								environment: {
									featureAppId: featureApp.trackingId,
								},
							},
						};
					}
				}}
			/>
		);
	};

	return (
		<>
			<CTA
				data-testid="redirect-cta"
				tag="button"
				emphasis={emphasis}
				size={isMobile ? 'large' : 'small'}
				stretchContent={{
					[Breakpoints.default]: true,
					[Breakpoints.b560]: false,
				}}
				onClick={handleOnClick}
			>
				{copy}
			</CTA>
			{renderOneformV1()}
		</>
	);
};
